import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'

@Injectable()
export class RegisterService {
    constructor(private http: HttpClient) {
    }

    createAccount(lead:any): any {
        // console.log(JSON.stringify(lead));
        return this.http.post(Configuration.apiUrl + 'api/lead/CreateAccountFromLead', JSON.stringify(lead), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getByEmail(email:string): any {
        return this.http.get(Configuration.apiUrl + 'api/Lead/GetByEmail?email=' + email)
    }

    getPlatforms(): any {
        return this.http.get(Configuration.apiUrl + 'api/platform/GetPlatforms')
    }

    getLeadByEmail(email: string): any {
        return this.http.get(Configuration.apiUrl + 'Api/Lead/GetByEmail?email=' + email)
    }

    getSalesAmountEnums(): any {
        return this.http.get(Configuration.apiUrl + 'api/Lead/GetSalesAmountEnums')
    }
    
    hasAccount(email:string): any {
        return this.http.get(Configuration.apiUrl + 'api/Lead/HasAccount?email=' + email)
    }

    hasDomain(domain:string): any {
        return this.http.get(Configuration.apiUrl + 'api/Lead/HasDomain?domain=' + domain)
    }

    login(username: string, password: string): any {
        let headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        });

        let body = new HttpParams()
            .set('username', username)
            .set('password', password)
            .set('scope', 'store')
            .set('grant_type', "password");

        return this.http.post(Configuration.apiUrl + 'account/login', body.toString(), { headers: headers })
    }

    saveLead(lead:any): any {
        return this.http.post(Configuration.apiUrl + 'api/Lead/Save', JSON.stringify(lead), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    updateDomainStoreAndLead(storeDto: any): any{
        return this.http.post(Configuration.apiUrl + 'api/platform/UpdateDomainStoreAndLead', JSON.stringify(storeDto), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    //ngolist = "seo1,seo2"
    updateStoreAndLead(storeDto: any, ngoList:string): any{
        return this.http.post(Configuration.apiUrl + 'api/platform/UpdateStoreAndLead?ngoList=' + ngoList, JSON.stringify(storeDto), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    validateDomain(domain:string) {
        var re = /^(((http|https|):\/\/)|www.|)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?($|([\/a-zA-Z0-9-]+))$/i;
        return re.test(String(domain).toLowerCase());
    }

    validateEmail(email:string) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

}
